import { trackError, type TrackErrorOptions } from '../errorReporter';

export const isValidLocale = (locale: unknown, trackOptions?: TrackErrorOptions): boolean => {
  try {
    if (typeof locale === 'string') {
      // Calling a formatting function with any number just to see if an error occurs
      Intl.NumberFormat(locale).format(1);
      return true;
    }
    return false;
  } catch (error) {
    if (trackOptions) {
      trackError(error, trackOptions);
    }
    return false;
  }
};
